export function useLoginState() {
  const state = useState<any>('_loginState', () => null)

  function setEmail(email: string) {
    state.value = {
      ...state.value,
      email,
    }
  }

  function setPhoneNumber(phoneNumber: string | null) {
    state.value = {
      ...state.value,
      phoneNumber,
    }
  }

  function setToken(token: null | string) {
    state.value = {
      ...state.value,
      token,
    }
  }

  function setType(type: 'email' | 'sms') {
    state.value = {
      ...state.value,
      type,
    }
  }

  const isValid = computed(() => {
    return !!(state.value?.email && state.value?.token)
  })

  return {
    email: computed(() => state.value?.email),
    setEmail,
    token: computed(() => state.value?.token),
    setToken,
    isValid,
    type: computed(() => state.value?.type),
    setType,
    phoneNumber: computed(() => state.value?.phoneNumber),
    setPhoneNumber,
  }
}
